// removed by extract-text-webpack-plugin
module.exports = {"container":"PQ--k","left":"_3UGsV","wrapper":"a_zC1","titleWrapper":"_3FpAV","title":"_3EBa0","descriptionWrapper":"Cvyi1","description":"CrPBO"};


//////////////////
// WEBPACK FOOTER
// ./app/components/page-description/page-description.scss
// module id = 1436
// module chunks = 0